import React from 'react';

// libs
import { DomElement } from 'html-react-parser';
import get from 'lodash/get';

// components
import Section from '../section/section';
import { IAuthorData } from '../../utils/authorsDataResolver';
import { ICaseStudyCategories } from '../../templates/case-studies-page';
import { IElevatoListItem } from '../../templates/page';

const getCodeComponent = (domNode: DomElement): string | null => {
  return get(domNode, 'attribs["data-codename"]') || null;
};

const isLinkedComponent = (domNode: DomElement): boolean => {
  return (
    domNode.name === 'object' &&
    !!domNode.attribs &&
    domNode.attribs.type === 'application/kenticocloud'
  );
};

const getComponent = (
  codename: string,
  linkedItems: IKontentItem[]
): IKontentItem | undefined => {
  return linkedItems.find(item => item.system.codename === codename);
};

export const replaceNode = (
  domNode: DomElement,
  linkedItems: IKontentItem[],
  allAuthors?: boolean,
  articles?: {
    featured: IKontentItem[];
    notFeatured: IKontentItem[];
  },
  latestArticles?: IBlogArticle[],
  caseStudies?: ICaseStudyData,
  nextCaseStudy?: ICaseStudyNext,
  authors?: IAuthorData[],
  caseStudyCategories?: ICaseStudyCategories,
  jobOffersElevato?: IElevatoListItem[]
): false | JSX.Element | undefined => {
  if (isLinkedComponent(domNode)) {
    const code = getCodeComponent(domNode);
    if (!code) return false;
    const linkedComponent = getComponent(code, linkedItems);
    if (!linkedComponent) return false;

    return (
      <Section
        linkedItem={linkedComponent}
        articles={articles}
        allAuthors={allAuthors}
        latestArticles={latestArticles}
        caseStudies={caseStudies}
        nextCaseStudy={nextCaseStudy}
        authors={authors}
        caseStudyCategories={caseStudyCategories}
        jobOffersElevato={jobOffersElevato}
      />
    );
  }
};
